import React from 'react'
import { Segment, Grid } from 'semantic-ui-react'
import colors from './../js/colors'

export default () => {
  return (
    <div>
      <Segment inverted style={{ backgroundColor: colors.dark }}>
        <Grid inverted stackable>
          <Grid.Row columns="equal" textAlign="justified" verticalAlign="middle">
            <Grid.Column width={4}>{/* <Icon name="plus" size="big" color={colors.mediumDark} /> */}</Grid.Column>
            <Grid.Column width={12}>
              <h3 style={{ color: colors.light }}>Manutenção</h3>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="equal" textAlign="justified">
            <Grid.Column>
              <p>
                Precisa ajustar seu varal? Ou trocar alguma peça? Ou até mesmo troca-lo?! Possuímos manutenção e uma grande
                variedade de acessórios para varais.
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </div>
  )
}
